import { AbilityBuilder, Ability } from '@casl/ability';
import { SET_USER } from '@/store/modules/auth/mutation-types';

export const ability = new Ability();

const updateAbilities = () => {
  const { rules } = new AbilityBuilder();
  ability.update(rules);
};

export const CaslVuex = (store) => store.subscribe((mutation) => {
  switch (mutation.type) {
    case SET_USER:
      updateAbilities();
      break;
    default:
  }
});
